import * as React from "react";
const StatsIcon = (props) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 20V4M18 20V16M12 20V10"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default StatsIcon;
